import { LinkPosition } from '../../../graphql/__generated/graphql';
import { SceneGuid } from './Scene';
import { Position } from '@ael/core-api';

export const LinkPositionHelper = {
  toLinkPosition: (position: Position): LinkPosition => ({
    __typename: 'LinkPosition',
    xAxis: position.sceneCoordinates.x,
    yAxis: position.sceneCoordinates.y,
    sceneIndex: position.virtualTourScene.sceneIndex,
  }),
  toCoordinates: (linkPosition: LinkPosition, originSceneGuid: SceneGuid): Position => ({
    sceneCoordinates: {
      x: linkPosition.xAxis,
      y: linkPosition.yAxis,
    },
    virtualTourScene: {
      sceneGuid: originSceneGuid,
      sceneIndex: linkPosition.sceneIndex,
    },
  }),
};
